export function Modal({ closeModal, heading, content }) {
  return (
    <div className="content-backdrop content-backdrop--show">
      <div className="content-backdrop__content">
        <div className="data-container py-5 px-3 px-lg-5">
          {heading && (
            <h3 className="heading-h3 heading-lg-h2 mb-2 text-center">
              {heading}
            </h3>
          )}
          {content}
        </div>
        <button
          type="button"
          onClick={closeModal}
          className="button content-backdrop__close"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
